import { render, staticRenderFns } from "./upgradeTypeUPG.vue?vue&type=template&id=1063eb6b&scoped=true&"
import script from "./upgradeTypeUPG.vue?vue&type=script&lang=js&"
export * from "./upgradeTypeUPG.vue?vue&type=script&lang=js&"
import style0 from "./upgradeTypeUPG.vue?vue&type=style&index=0&id=1063eb6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1063eb6b",
  null
  
)

export default component.exports